export default function CalendarHeader({ value, setValue, header }) {
    function currentMonthName() {
        return value.format("MMM");
    }
    function currentYear() {
        return value.format("YYYY");
    }

    function prevMonth() {
        return value.clone().subtract(1, "month");
    }
    function nextMonth() {
        return value.clone().add(1, "month");
    }

    function thisMonth() {
        return value.isSame(new Date(), "month");
    }
    return (
        <div className={header?.headerParent}>
            <div className={header?.previous} onClick={() => setValue(prevMonth())}>
                {String.fromCharCode(171)}
            </div>
            <div className={header?.current}>
                {currentMonthName()} {currentYear()}
            </div>
            <div className={header?.next} onClick={() => !thisMonth() && setValue(nextMonth())}>
                {!thisMonth() ? String.fromCharCode(187) : null}
            </div>
        </div>
    );
}
